import logger from '@/logger';
import router from '@/router';
import Api from './api';

// Helper that checks if the DevetryUAT cookie exists
import CookieHelper from './cookieHelper';

export default {
  setUser: ({ commit }, payload) => {
    commit('setUser', payload);
  },
  login: async ({ commit, dispatch }, payload) => {
    commit('updateFetchingUserStatus', 'Fetching');
    try {
      const res = await Api.sendLoginCreds(payload);
      commit('setUser', res.data);
      dispatch('pageLoad', {}, { root: true });
    } catch (err) {
      commit('setLoginError', err);
    }
  },
  logout({ commit, dispatch }, options = {}) {
    CookieHelper.eraseCookie('DevetryUAT');
    commit('LOGOUT');
    this.hagrid.emit('logout');

    // this is ugly. better would be to put the routing in the components
    if (!options.noRoute) {
      logger.log('routing to /login from logout action');
      router.push('/login');
    }
  },
  checkAuth: ({ commit }) => {
    // check for cookie
    const myCookie = CookieHelper.getCookie('DevetryUAT');
    if (myCookie) commit('setToken', myCookie);
    commit('LOGIN_COMPLETE');
  },
  register: async ({ commit, dispatch }, payload) => {
    commit('updateFetchingUserStatus', 'Fetching');
    try {
      await dispatch('logout', { noRoute: true });
      const res = await Api.registerUser(payload);
      await dispatch('login', payload);
      await dispatch('projects/createProject', {
        orgId: res.data.access[0].orgId,
        projectName: 'My First Project',
      }, { root: true });
    } catch (err) {
      commit('setRegistrationError', err.response.data);
    }
  },
  joinOrg: async ({ commit }, payload) => {
    commit('ADD_ACCESS', payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js